import "@arco-design/web-react/es/Popover/style";
import _Popover from "@arco-design/web-react/es/Popover";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconWoman from "@arco-design/web-react/icon/react-icon/IconWoman";
import _IconWifi from "@arco-design/web-react/icon/react-icon/IconWifi";
import _IconVideoCamera from "@arco-design/web-react/icon/react-icon/IconVideoCamera";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconUserGroup from "@arco-design/web-react/icon/react-icon/IconUserGroup";
import _IconUserAdd from "@arco-design/web-react/icon/react-icon/IconUserAdd";
import _IconUnlock from "@arco-design/web-react/icon/react-icon/IconUnlock";
import _IconTrophy from "@arco-design/web-react/icon/react-icon/IconTrophy";
import _IconTool from "@arco-design/web-react/icon/react-icon/IconTool";
import _IconThunderbolt from "@arco-design/web-react/icon/react-icon/IconThunderbolt";
import _IconTags from "@arco-design/web-react/icon/react-icon/IconTags";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconSun from "@arco-design/web-react/icon/react-icon/IconSun";
import _IconSubscribed from "@arco-design/web-react/icon/react-icon/IconSubscribed";
import _IconSubscribe from "@arco-design/web-react/icon/react-icon/IconSubscribe";
import _IconSubscribeAdd from "@arco-design/web-react/icon/react-icon/IconSubscribeAdd";
import _IconStorage from "@arco-design/web-react/icon/react-icon/IconStorage";
import _IconStamp from "@arco-design/web-react/icon/react-icon/IconStamp";
import _IconSkin from "@arco-design/web-react/icon/react-icon/IconSkin";
import _IconShake from "@arco-design/web-react/icon/react-icon/IconShake";
import _IconSchedule from "@arco-design/web-react/icon/react-icon/IconSchedule";
import _IconSafe from "@arco-design/web-react/icon/react-icon/IconSafe";
import _IconRobot from "@arco-design/web-react/icon/react-icon/IconRobot";
import _IconRobotAdd from "@arco-design/web-react/icon/react-icon/IconRobotAdd";
import _IconQrcode from "@arco-design/web-react/icon/react-icon/IconQrcode";
import _IconPushpin from "@arco-design/web-react/icon/react-icon/IconPushpin";
import _IconPublic from "@arco-design/web-react/icon/react-icon/IconPublic";
import _IconPrinter from "@arco-design/web-react/icon/react-icon/IconPrinter";
import _IconPhone from "@arco-design/web-react/icon/react-icon/IconPhone";
import _IconPen from "@arco-design/web-react/icon/react-icon/IconPen";
import _IconPalette from "@arco-design/web-react/icon/react-icon/IconPalette";
import _IconNotification from "@arco-design/web-react/icon/react-icon/IconNotification";
import _IconNotificationClose from "@arco-design/web-react/icon/react-icon/IconNotificationClose";
import _IconNav from "@arco-design/web-react/icon/react-icon/IconNav";
import _IconMosaic from "@arco-design/web-react/icon/react-icon/IconMosaic";
import _IconMoon from "@arco-design/web-react/icon/react-icon/IconMoon";
import _IconMobile from "@arco-design/web-react/icon/react-icon/IconMobile";
import _IconMindMapping from "@arco-design/web-react/icon/react-icon/IconMindMapping";
import _IconMenu from "@arco-design/web-react/icon/react-icon/IconMenu";
import _IconMan from "@arco-design/web-react/icon/react-icon/IconMan";
import _IconLoop from "@arco-design/web-react/icon/react-icon/IconLoop";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import _IconLocation from "@arco-design/web-react/icon/react-icon/IconLocation";
import _IconLoading from "@arco-design/web-react/icon/react-icon/IconLoading";
import _IconLayout from "@arco-design/web-react/icon/react-icon/IconLayout";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import _IconInteraction from "@arco-design/web-react/icon/react-icon/IconInteraction";
import _IconImage from "@arco-design/web-react/icon/react-icon/IconImage";
import _IconImageClose from "@arco-design/web-react/icon/react-icon/IconImageClose";
import _IconIdcard from "@arco-design/web-react/icon/react-icon/IconIdcard";
import _IconGift from "@arco-design/web-react/icon/react-icon/IconGift";
import _IconFolder from "@arco-design/web-react/icon/react-icon/IconFolder";
import _IconFolderDelete from "@arco-design/web-react/icon/react-icon/IconFolderDelete";
import _IconFolderAdd from "@arco-design/web-react/icon/react-icon/IconFolderAdd";
import _IconFire from "@arco-design/web-react/icon/react-icon/IconFire";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconFileVideo from "@arco-design/web-react/icon/react-icon/IconFileVideo";
import _IconFilePdf from "@arco-design/web-react/icon/react-icon/IconFilePdf";
import _IconFileImage from "@arco-design/web-react/icon/react-icon/IconFileImage";
import _IconFileAudio from "@arco-design/web-react/icon/react-icon/IconFileAudio";
import _IconExperiment from "@arco-design/web-react/icon/react-icon/IconExperiment";
import _IconEmpty from "@arco-design/web-react/icon/react-icon/IconEmpty";
import _IconEmail from "@arco-design/web-react/icon/react-icon/IconEmail";
import _IconEar from "@arco-design/web-react/icon/react-icon/IconEar";
import _IconDriveFile from "@arco-design/web-react/icon/react-icon/IconDriveFile";
import _IconDragDot from "@arco-design/web-react/icon/react-icon/IconDragDot";
import _IconDragDotVertical from "@arco-design/web-react/icon/react-icon/IconDragDotVertical";
import _IconDice from "@arco-design/web-react/icon/react-icon/IconDice";
import _IconDesktop from "@arco-design/web-react/icon/react-icon/IconDesktop";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import _IconCopyright from "@arco-design/web-react/icon/react-icon/IconCopyright";
import _IconCompass from "@arco-design/web-react/icon/react-icon/IconCompass";
import _IconCommon from "@arco-design/web-react/icon/react-icon/IconCommon";
import _IconCommand from "@arco-design/web-react/icon/react-icon/IconCommand";
import _IconCloud from "@arco-design/web-react/icon/react-icon/IconCloud";
import _IconCamera from "@arco-design/web-react/icon/react-icon/IconCamera";
import _IconCalendar from "@arco-design/web-react/icon/react-icon/IconCalendar";
import _IconCalendarClock from "@arco-design/web-react/icon/react-icon/IconCalendarClock";
import _IconBulb from "@arco-design/web-react/icon/react-icon/IconBulb";
import _IconBug from "@arco-design/web-react/icon/react-icon/IconBug";
import _IconBranch from "@arco-design/web-react/icon/react-icon/IconBranch";
import _IconBook from "@arco-design/web-react/icon/react-icon/IconBook";
import _IconArchive from "@arco-design/web-react/icon/react-icon/IconArchive";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconPenFill from "@arco-design/web-react/icon/react-icon/IconPenFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import _IconFaceSmileFill from "@arco-design/web-react/icon/react-icon/IconFaceSmileFill";
import _IconFaceMehFill from "@arco-design/web-react/icon/react-icon/IconFaceMehFill";
import _IconFaceFrownFill from "@arco-design/web-react/icon/react-icon/IconFaceFrownFill";
import _IconEnglishFill from "@arco-design/web-react/icon/react-icon/IconEnglishFill";
import _IconChineseFill from "@arco-design/web-react/icon/react-icon/IconChineseFill";
import _IconWeibo from "@arco-design/web-react/icon/react-icon/IconWeibo";
import _IconWechatpay from "@arco-design/web-react/icon/react-icon/IconWechatpay";
import _IconWechat from "@arco-design/web-react/icon/react-icon/IconWechat";
import _IconTwitter from "@arco-design/web-react/icon/react-icon/IconTwitter";
import _IconQq from "@arco-design/web-react/icon/react-icon/IconQq";
import _IconQqZone from "@arco-design/web-react/icon/react-icon/IconQqZone";
import _IconGoogle from "@arco-design/web-react/icon/react-icon/IconGoogle";
import _IconGitlab from "@arco-design/web-react/icon/react-icon/IconGitlab";
import _IconGithub from "@arco-design/web-react/icon/react-icon/IconGithub";
import _IconFacebook from "@arco-design/web-react/icon/react-icon/IconFacebook";
import _IconCodepen from "@arco-design/web-react/icon/react-icon/IconCodepen";
import _IconCodeSandbox from "@arco-design/web-react/icon/react-icon/IconCodeSandbox";
import _IconAlipayCircle from "@arco-design/web-react/icon/react-icon/IconAlipayCircle";
import _IconWeiboCircleFill from "@arco-design/web-react/icon/react-icon/IconWeiboCircleFill";
import _IconTwitterCircleFill from "@arco-design/web-react/icon/react-icon/IconTwitterCircleFill";
import _IconQqCircleFill from "@arco-design/web-react/icon/react-icon/IconQqCircleFill";
import _IconGoogleCircleFill from "@arco-design/web-react/icon/react-icon/IconGoogleCircleFill";
import _IconFacebookSquareFill from "@arco-design/web-react/icon/react-icon/IconFacebookSquareFill";
import _IconFaceBookCircleFill from "@arco-design/web-react/icon/react-icon/IconFaceBookCircleFill";
import _IconXiguaColor from "@arco-design/web-react/icon/react-icon/IconXiguaColor";
import _IconTiktokColor from "@arco-design/web-react/icon/react-icon/IconTiktokColor";
import _IconLarkColor from "@arco-design/web-react/icon/react-icon/IconLarkColor";
import _IconBytedanceColor from "@arco-design/web-react/icon/react-icon/IconBytedanceColor";
import _IconSound from "@arco-design/web-react/icon/react-icon/IconSound";
import _IconSkipPrevious from "@arco-design/web-react/icon/react-icon/IconSkipPrevious";
import _IconSkipNext from "@arco-design/web-react/icon/react-icon/IconSkipNext";
import _IconRecord from "@arco-design/web-react/icon/react-icon/IconRecord";
import _IconRecordStop from "@arco-design/web-react/icon/react-icon/IconRecordStop";
import _IconPlayCircle from "@arco-design/web-react/icon/react-icon/IconPlayCircle";
import _IconPlayArrow from "@arco-design/web-react/icon/react-icon/IconPlayArrow";
import _IconPause from "@arco-design/web-react/icon/react-icon/IconPause";
import _IconPauseCircle from "@arco-design/web-react/icon/react-icon/IconPauseCircle";
import _IconMute from "@arco-design/web-react/icon/react-icon/IconMute";
import _IconMusic from "@arco-design/web-react/icon/react-icon/IconMusic";
import _IconLiveBroadcast from "@arco-design/web-react/icon/react-icon/IconLiveBroadcast";
import _IconFullscreen from "@arco-design/web-react/icon/react-icon/IconFullscreen";
import _IconFullscreenExit from "@arco-design/web-react/icon/react-icon/IconFullscreenExit";
import _IconForward from "@arco-design/web-react/icon/react-icon/IconForward";
import _IconBackward from "@arco-design/web-react/icon/react-icon/IconBackward";
import _IconSoundFill from "@arco-design/web-react/icon/react-icon/IconSoundFill";
import _IconSkipPreviousFill from "@arco-design/web-react/icon/react-icon/IconSkipPreviousFill";
import _IconSkipNextFill from "@arco-design/web-react/icon/react-icon/IconSkipNextFill";
import _IconPlayCircleFill from "@arco-design/web-react/icon/react-icon/IconPlayCircleFill";
import _IconPlayArrowFill from "@arco-design/web-react/icon/react-icon/IconPlayArrowFill";
import _IconPauseCircleFill from "@arco-design/web-react/icon/react-icon/IconPauseCircleFill";
import _IconMuteFill from "@arco-design/web-react/icon/react-icon/IconMuteFill";
import _IconZoomOut from "@arco-design/web-react/icon/react-icon/IconZoomOut";
import _IconZoomIn from "@arco-design/web-react/icon/react-icon/IconZoomIn";
import _IconUnorderedList from "@arco-design/web-react/icon/react-icon/IconUnorderedList";
import _IconUndo from "@arco-design/web-react/icon/react-icon/IconUndo";
import _IconUnderline from "@arco-design/web-react/icon/react-icon/IconUnderline";
import _IconStrikethrough from "@arco-design/web-react/icon/react-icon/IconStrikethrough";
import _IconSort from "@arco-design/web-react/icon/react-icon/IconSort";
import _IconSortDescending from "@arco-design/web-react/icon/react-icon/IconSortDescending";
import _IconSortAscending from "@arco-design/web-react/icon/react-icon/IconSortAscending";
import _IconScissor from "@arco-design/web-react/icon/react-icon/IconScissor";
import _IconRedo from "@arco-design/web-react/icon/react-icon/IconRedo";
import _IconQuote from "@arco-design/web-react/icon/react-icon/IconQuote";
import _IconPaste from "@arco-design/web-react/icon/react-icon/IconPaste";
import _IconOriginalSize from "@arco-design/web-react/icon/react-icon/IconOriginalSize";
import _IconOrderedList from "@arco-design/web-react/icon/react-icon/IconOrderedList";
import _IconObliqueLine from "@arco-design/web-react/icon/react-icon/IconObliqueLine";
import _IconLink from "@arco-design/web-react/icon/react-icon/IconLink";
import _IconLineHeight from "@arco-design/web-react/icon/react-icon/IconLineHeight";
import _IconItalic from "@arco-design/web-react/icon/react-icon/IconItalic";
import _IconHighlight from "@arco-design/web-react/icon/react-icon/IconHighlight";
import _IconH7 from "@arco-design/web-react/icon/react-icon/IconH7";
import _IconH6 from "@arco-design/web-react/icon/react-icon/IconH6";
import _IconH5 from "@arco-design/web-react/icon/react-icon/IconH5";
import _IconH4 from "@arco-design/web-react/icon/react-icon/IconH4";
import _IconH3 from "@arco-design/web-react/icon/react-icon/IconH3";
import _IconH2 from "@arco-design/web-react/icon/react-icon/IconH2";
import _IconH from "@arco-design/web-react/icon/react-icon/IconH1";
import _IconFormula from "@arco-design/web-react/icon/react-icon/IconFormula";
import _IconFontColors from "@arco-design/web-react/icon/react-icon/IconFontColors";
import _IconFindReplace from "@arco-design/web-react/icon/react-icon/IconFindReplace";
import _IconFilter from "@arco-design/web-react/icon/react-icon/IconFilter";
import _IconEraser from "@arco-design/web-react/icon/react-icon/IconEraser";
import _IconEdit from "@arco-design/web-react/icon/react-icon/IconEdit";
import _IconDelete from "@arco-design/web-react/icon/react-icon/IconDelete";
import _IconCopy from "@arco-design/web-react/icon/react-icon/IconCopy";
import _IconBrush from "@arco-design/web-react/icon/react-icon/IconBrush";
import _IconBold from "@arco-design/web-react/icon/react-icon/IconBold";
import _IconBgColors from "@arco-design/web-react/icon/react-icon/IconBgColors";
import _IconAttachment from "@arco-design/web-react/icon/react-icon/IconAttachment";
import _IconAlignRight from "@arco-design/web-react/icon/react-icon/IconAlignRight";
import _IconAlignLeft from "@arco-design/web-react/icon/react-icon/IconAlignLeft";
import _IconAlignCenter from "@arco-design/web-react/icon/react-icon/IconAlignCenter";
import _IconVoice from "@arco-design/web-react/icon/react-icon/IconVoice";
import _IconUpload from "@arco-design/web-react/icon/react-icon/IconUpload";
import _IconTranslate from "@arco-design/web-react/icon/react-icon/IconTranslate";
import _IconThumbUp from "@arco-design/web-react/icon/react-icon/IconThumbUp";
import _IconThumbDown from "@arco-design/web-react/icon/react-icon/IconThumbDown";
import _IconSync from "@arco-design/web-react/icon/react-icon/IconSync";
import _IconStar from "@arco-design/web-react/icon/react-icon/IconStar";
import _IconShareInternal from "@arco-design/web-react/icon/react-icon/IconShareInternal";
import _IconShareExternal from "@arco-design/web-react/icon/react-icon/IconShareExternal";
import _IconShareAlt from "@arco-design/web-react/icon/react-icon/IconShareAlt";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconSend from "@arco-design/web-react/icon/react-icon/IconSend";
import _IconSelectAll from "@arco-design/web-react/icon/react-icon/IconSelectAll";
import _IconSearch from "@arco-design/web-react/icon/react-icon/IconSearch";
import _IconScan from "@arco-design/web-react/icon/react-icon/IconScan";
import _IconSave from "@arco-design/web-react/icon/react-icon/IconSave";
import _IconReply from "@arco-design/web-react/icon/react-icon/IconReply";
import _IconRefresh from "@arco-design/web-react/icon/react-icon/IconRefresh";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import _IconMore from "@arco-design/web-react/icon/react-icon/IconMore";
import _IconMoreVertical from "@arco-design/web-react/icon/react-icon/IconMoreVertical";
import _IconMessage from "@arco-design/web-react/icon/react-icon/IconMessage";
import _IconMessageBanned from "@arco-design/web-react/icon/react-icon/IconMessageBanned";
import _IconList from "@arco-design/web-react/icon/react-icon/IconList";
import _IconLaunch from "@arco-design/web-react/icon/react-icon/IconLaunch";
import _IconImport from "@arco-design/web-react/icon/react-icon/IconImport";
import _IconHome from "@arco-design/web-react/icon/react-icon/IconHome";
import _IconHistory from "@arco-design/web-react/icon/react-icon/IconHistory";
import _IconHeart from "@arco-design/web-react/icon/react-icon/IconHeart";
import _IconEye from "@arco-design/web-react/icon/react-icon/IconEye";
import _IconEyeInvisible from "@arco-design/web-react/icon/react-icon/IconEyeInvisible";
import _IconExport from "@arco-design/web-react/icon/react-icon/IconExport";
import _IconDownload from "@arco-design/web-react/icon/react-icon/IconDownload";
import _IconCustomerService from "@arco-design/web-react/icon/react-icon/IconCustomerService";
import _IconCode from "@arco-design/web-react/icon/react-icon/IconCode";
import _IconCodeSquare from "@arco-design/web-react/icon/react-icon/IconCodeSquare";
import _IconCodeBlock from "@arco-design/web-react/icon/react-icon/IconCodeBlock";
import _IconCloudDownload from "@arco-design/web-react/icon/react-icon/IconCloudDownload";
import _IconAt from "@arco-design/web-react/icon/react-icon/IconAt";
import _IconThumbUpFill from "@arco-design/web-react/icon/react-icon/IconThumbUpFill";
import _IconThumbDownFill from "@arco-design/web-react/icon/react-icon/IconThumbDownFill";
import _IconStarFill from "@arco-design/web-react/icon/react-icon/IconStarFill";
import _IconHeartFill from "@arco-design/web-react/icon/react-icon/IconHeartFill";
import _IconStop from "@arco-design/web-react/icon/react-icon/IconStop";
import _IconQuestion from "@arco-design/web-react/icon/react-icon/IconQuestion";
import _IconQuestionCircle from "@arco-design/web-react/icon/react-icon/IconQuestionCircle";
import _IconPlus from "@arco-design/web-react/icon/react-icon/IconPlus";
import _IconPlusCircle from "@arco-design/web-react/icon/react-icon/IconPlusCircle";
import _IconMinus from "@arco-design/web-react/icon/react-icon/IconMinus";
import _IconMinusCircle from "@arco-design/web-react/icon/react-icon/IconMinusCircle";
import _IconInfo from "@arco-design/web-react/icon/react-icon/IconInfo";
import _IconInfoCircle from "@arco-design/web-react/icon/react-icon/IconInfoCircle";
import _IconExclamation from "@arco-design/web-react/icon/react-icon/IconExclamation";
import _IconExclamationCircle from "@arco-design/web-react/icon/react-icon/IconExclamationCircle";
import _IconClose from "@arco-design/web-react/icon/react-icon/IconClose";
import _IconCloseCircle from "@arco-design/web-react/icon/react-icon/IconCloseCircle";
import _IconClockCircle from "@arco-design/web-react/icon/react-icon/IconClockCircle";
import _IconCheck from "@arco-design/web-react/icon/react-icon/IconCheck";
import _IconCheckSquare from "@arco-design/web-react/icon/react-icon/IconCheckSquare";
import _IconCheckCircle from "@arco-design/web-react/icon/react-icon/IconCheckCircle";
import _IconQuestionCircleFill from "@arco-design/web-react/icon/react-icon/IconQuestionCircleFill";
import _IconPlusCircleFill from "@arco-design/web-react/icon/react-icon/IconPlusCircleFill";
import _IconMinusCircleFill from "@arco-design/web-react/icon/react-icon/IconMinusCircleFill";
import _IconInfoCircleFill from "@arco-design/web-react/icon/react-icon/IconInfoCircleFill";
import _IconExclamationPolygonFill from "@arco-design/web-react/icon/react-icon/IconExclamationPolygonFill";
import _IconExclamationCircleFill from "@arco-design/web-react/icon/react-icon/IconExclamationCircleFill";
import _IconCloseCircleFill from "@arco-design/web-react/icon/react-icon/IconCloseCircleFill";
import _IconCheckCircleFill from "@arco-design/web-react/icon/react-icon/IconCheckCircleFill";
import _IconUp from "@arco-design/web-react/icon/react-icon/IconUp";
import _IconUpCircle from "@arco-design/web-react/icon/react-icon/IconUpCircle";
import _IconToTop from "@arco-design/web-react/icon/react-icon/IconToTop";
import _IconToRight from "@arco-design/web-react/icon/react-icon/IconToRight";
import _IconToLeft from "@arco-design/web-react/icon/react-icon/IconToLeft";
import _IconToBottom from "@arco-design/web-react/icon/react-icon/IconToBottom";
import _IconSwap from "@arco-design/web-react/icon/react-icon/IconSwap";
import _IconShrink from "@arco-design/web-react/icon/react-icon/IconShrink";
import _IconRotateRight from "@arco-design/web-react/icon/react-icon/IconRotateRight";
import _IconRotateLeft from "@arco-design/web-react/icon/react-icon/IconRotateLeft";
import _IconRight from "@arco-design/web-react/icon/react-icon/IconRight";
import _IconRightCircle from "@arco-design/web-react/icon/react-icon/IconRightCircle";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconLeft from "@arco-design/web-react/icon/react-icon/IconLeft";
import _IconLeftCircle from "@arco-design/web-react/icon/react-icon/IconLeftCircle";
import _IconExpand from "@arco-design/web-react/icon/react-icon/IconExpand";
import _IconDragArrow from "@arco-design/web-react/icon/react-icon/IconDragArrow";
import _IconDown from "@arco-design/web-react/icon/react-icon/IconDown";
import _IconDownCircle from "@arco-design/web-react/icon/react-icon/IconDownCircle";
import _IconDoubleUp from "@arco-design/web-react/icon/react-icon/IconDoubleUp";
import _IconDoubleRight from "@arco-design/web-react/icon/react-icon/IconDoubleRight";
import _IconDoubleLeft from "@arco-design/web-react/icon/react-icon/IconDoubleLeft";
import _IconDoubleDown from "@arco-design/web-react/icon/react-icon/IconDoubleDown";
import _IconCaretUp from "@arco-design/web-react/icon/react-icon/IconCaretUp";
import _IconCaretRight from "@arco-design/web-react/icon/react-icon/IconCaretRight";
import _IconCaretLeft from "@arco-design/web-react/icon/react-icon/IconCaretLeft";
import _IconCaretDown from "@arco-design/web-react/icon/react-icon/IconCaretDown";
import _IconArrowUp from "@arco-design/web-react/icon/react-icon/IconArrowUp";
import _IconArrowRise from "@arco-design/web-react/icon/react-icon/IconArrowRise";
import _IconArrowRight from "@arco-design/web-react/icon/react-icon/IconArrowRight";
import _IconArrowLeft from "@arco-design/web-react/icon/react-icon/IconArrowLeft";
import _IconArrowFall from "@arco-design/web-react/icon/react-icon/IconArrowFall";
import _IconArrowDown from "@arco-design/web-react/icon/react-icon/IconArrowDown";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import React, { useState } from 'react';
import styles from './style/iconPicker.module.less';
const {
  Row,
  Col
} = _Grid;

// 获取所有图标的名称
const iconNames = ['arrow_down', 'arrow_fall', 'arrow_left', 'arrow_right', 'arrow_rise', 'arrow_up', 'caret_down', 'caret_left', 'caret_right', 'caret_up', 'double_down', 'double_left', 'double_right', 'double_up', 'down_circle', 'down', 'drag_arrow', 'expand', 'left_circle', 'left', 'menu_fold', 'menu_unfold', 'right_circle', 'right', 'rotate_left', 'rotate_right', 'shrink', 'swap', 'to_bottom', 'to_left', 'to_right', 'to_top', 'up_circle', 'up', 'check_circle_fill', 'close_circle_fill', 'exclamation_circle_fill', 'exclamation_polygon_fill', 'info_circle_fill', 'minus_circle_fill', 'plus_circle_fill', 'question_circle_fill', 'check_circle', 'check_square', 'check', 'clock_circle', 'close_circle', 'close', 'exclamation_circle', 'exclamation', 'info_circle', 'info', 'minus_circle', 'minus', 'plus_circle', 'plus', 'question_circle', 'question', 'stop', 'heart_fill', 'star_fill', 'thumb_down_fill', 'thumb_up_fill', 'at', 'cloud_download', 'code_block', 'code_square', 'code', 'customer_service', 'download', 'export', 'eye_invisible', 'eye', 'heart', 'history', 'home', 'import', 'launch', 'list', 'message_banned', 'message', 'more_vertical', 'more', 'poweroff', 'refresh', 'reply', 'save', 'scan', 'search', 'select_all', 'send', 'settings', 'share_alt', 'share_external', 'share_internal', 'star', 'sync', 'thumb_down', 'thumb_up', 'translate', 'upload', 'voice', 'align_center', 'align_left', 'align_right', 'attachment', 'bg_colors', 'bold', 'brush', 'copy', 'delete', 'edit', 'eraser', 'filter', 'find_replace', 'font_colors', 'formula', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'highlight', 'italic', 'line_height', 'link', 'oblique_line', 'ordered_list', 'original_size', 'paste', 'quote', 'redo', 'scissor', 'sort_ascending', 'sort_descending', 'sort', 'strikethrough', 'underline', 'undo', 'unordered_list', 'zoom_in', 'zoom_out', 'mute_fill', 'pause_circle_fill', 'play_arrow_fill', 'play_circle_fill', 'skip_next_fill', 'skip_previous_fill', 'sound_fill', 'backward', 'forward', 'fullscreen_exit', 'fullscreen', 'live_broadcast', 'music', 'mute', 'pause_circle', 'pause', 'play_arrow', 'play_circle', 'record_stop', 'record', 'skip_next', 'skip_previous', 'sound', 'bytedance_color', 'lark_color', 'tiktok_color', 'xigua_color', 'face_book_circle_fill', 'facebook_square_fill', 'google_circle_fill', 'qq_circle_fill', 'twitter_circle_fill', 'weibo_circle_fill', 'alipay_circle', 'code_sandbox', 'codepen', 'facebook', 'github', 'gitlab', 'google', 'qq_zone', 'qq', 'twitter', 'wechat', 'wechatpay', 'weibo', 'chinese_fill', 'english_fill', 'face_frown_fill', 'face_meh_fill', 'face_smile_fill', 'moon_fill', 'pen_fill', 'sun_fill', 'apps', 'archive', 'book', 'branch', 'bug', 'bulb', 'calendar_clock', 'calendar', 'camera', 'cloud', 'command', 'common', 'compass', 'copyright', 'dashboard', 'desktop', 'dice', 'drag_dot_vertical', 'drag_dot', 'drive_file', 'ear', 'email', 'empty', 'experiment', 'file_audio', 'file_image', 'file_pdf', 'file_video', 'file', 'fire', 'folder_add', 'folder_delete', 'folder', 'gift', 'idcard', 'image_close', 'image', 'interaction', 'language', 'layout', 'loading', 'location', 'lock', 'loop', 'man', 'menu', 'mind_mapping', 'mobile', 'moon', 'mosaic', 'nav', 'notification_close', 'notification', 'palette', 'pen', 'phone', 'printer', 'public', 'pushpin', 'qrcode', 'robot_add', 'robot', 'safe', 'schedule', 'shake', 'skin', 'stamp', 'storage', 'subscribe_add', 'subscribe', 'subscribed', 'sun', 'tag', 'tags', 'thunderbolt', 'tool', 'trophy', 'unlock', 'user_add', 'user_group', 'user', 'video_camera', 'wifi', 'woman'];
function getIconFromKey(key, props = {}, placeholder = false) {
  switch (key) {
    case 'arrow_down':
      return /*#__PURE__*/React.createElement(_IconArrowDown, props);
    case 'arrow_fall':
      return /*#__PURE__*/React.createElement(_IconArrowFall, props);
    case 'arrow_left':
      return /*#__PURE__*/React.createElement(_IconArrowLeft, props);
    case 'arrow_right':
      return /*#__PURE__*/React.createElement(_IconArrowRight, props);
    case 'arrow_rise':
      return /*#__PURE__*/React.createElement(_IconArrowRise, props);
    case 'arrow_up':
      return /*#__PURE__*/React.createElement(_IconArrowUp, props);
    case 'caret_down':
      return /*#__PURE__*/React.createElement(_IconCaretDown, props);
    case 'caret_left':
      return /*#__PURE__*/React.createElement(_IconCaretLeft, props);
    case 'caret_right':
      return /*#__PURE__*/React.createElement(_IconCaretRight, props);
    case 'caret_up':
      return /*#__PURE__*/React.createElement(_IconCaretUp, props);
    case 'double_down':
      return /*#__PURE__*/React.createElement(_IconDoubleDown, props);
    case 'double_left':
      return /*#__PURE__*/React.createElement(_IconDoubleLeft, props);
    case 'double_right':
      return /*#__PURE__*/React.createElement(_IconDoubleRight, props);
    case 'double_up':
      return /*#__PURE__*/React.createElement(_IconDoubleUp, props);
    case 'down_circle':
      return /*#__PURE__*/React.createElement(_IconDownCircle, props);
    case 'down':
      return /*#__PURE__*/React.createElement(_IconDown, props);
    case 'drag_arrow':
      return /*#__PURE__*/React.createElement(_IconDragArrow, props);
    case 'expand':
      return /*#__PURE__*/React.createElement(_IconExpand, props);
    case 'left_circle':
      return /*#__PURE__*/React.createElement(_IconLeftCircle, props);
    case 'left':
      return /*#__PURE__*/React.createElement(_IconLeft, props);
    case 'menu_fold':
      return /*#__PURE__*/React.createElement(_IconMenuFold, props);
    case 'menu_unfold':
      return /*#__PURE__*/React.createElement(_IconMenuUnfold, props);
    case 'right_circle':
      return /*#__PURE__*/React.createElement(_IconRightCircle, props);
    case 'right':
      return /*#__PURE__*/React.createElement(_IconRight, props);
    case 'rotate_left':
      return /*#__PURE__*/React.createElement(_IconRotateLeft, props);
    case 'rotate_right':
      return /*#__PURE__*/React.createElement(_IconRotateRight, props);
    case 'shrink':
      return /*#__PURE__*/React.createElement(_IconShrink, props);
    case 'swap':
      return /*#__PURE__*/React.createElement(_IconSwap, props);
    case 'to_bottom':
      return /*#__PURE__*/React.createElement(_IconToBottom, props);
    case 'to_left':
      return /*#__PURE__*/React.createElement(_IconToLeft, props);
    case 'to_right':
      return /*#__PURE__*/React.createElement(_IconToRight, props);
    case 'to_top':
      return /*#__PURE__*/React.createElement(_IconToTop, props);
    case 'up_circle':
      return /*#__PURE__*/React.createElement(_IconUpCircle, props);
    case 'up':
      return /*#__PURE__*/React.createElement(_IconUp, props);
    case 'check_circle_fill':
      return /*#__PURE__*/React.createElement(_IconCheckCircleFill, props);
    case 'close_circle_fill':
      return /*#__PURE__*/React.createElement(_IconCloseCircleFill, props);
    case 'exclamation_circle_fill':
      return /*#__PURE__*/React.createElement(_IconExclamationCircleFill, props);
    case 'exclamation_polygon_fill':
      return /*#__PURE__*/React.createElement(_IconExclamationPolygonFill, props);
    case 'info_circle_fill':
      return /*#__PURE__*/React.createElement(_IconInfoCircleFill, props);
    case 'minus_circle_fill':
      return /*#__PURE__*/React.createElement(_IconMinusCircleFill, props);
    case 'plus_circle_fill':
      return /*#__PURE__*/React.createElement(_IconPlusCircleFill, props);
    case 'question_circle_fill':
      return /*#__PURE__*/React.createElement(_IconQuestionCircleFill, props);
    case 'check_circle':
      return /*#__PURE__*/React.createElement(_IconCheckCircle, props);
    case 'check_square':
      return /*#__PURE__*/React.createElement(_IconCheckSquare, props);
    case 'check':
      return /*#__PURE__*/React.createElement(_IconCheck, props);
    case 'clock_circle':
      return /*#__PURE__*/React.createElement(_IconClockCircle, props);
    case 'close_circle':
      return /*#__PURE__*/React.createElement(_IconCloseCircle, props);
    case 'close':
      return /*#__PURE__*/React.createElement(_IconClose, props);
    case 'exclamation_circle':
      return /*#__PURE__*/React.createElement(_IconExclamationCircle, props);
    case 'exclamation':
      return /*#__PURE__*/React.createElement(_IconExclamation, props);
    case 'info_circle':
      return /*#__PURE__*/React.createElement(_IconInfoCircle, props);
    case 'info':
      return /*#__PURE__*/React.createElement(_IconInfo, props);
    case 'minus_circle':
      return /*#__PURE__*/React.createElement(_IconMinusCircle, props);
    case 'minus':
      return /*#__PURE__*/React.createElement(_IconMinus, props);
    case 'plus_circle':
      return /*#__PURE__*/React.createElement(_IconPlusCircle, props);
    case 'plus':
      return /*#__PURE__*/React.createElement(_IconPlus, props);
    case 'question_circle':
      return /*#__PURE__*/React.createElement(_IconQuestionCircle, props);
    case 'question':
      return /*#__PURE__*/React.createElement(_IconQuestion, props);
    case 'stop':
      return /*#__PURE__*/React.createElement(_IconStop, props);
    case 'heart_fill':
      return /*#__PURE__*/React.createElement(_IconHeartFill, props);
    case 'star_fill':
      return /*#__PURE__*/React.createElement(_IconStarFill, props);
    case 'thumb_down_fill':
      return /*#__PURE__*/React.createElement(_IconThumbDownFill, props);
    case 'thumb_up_fill':
      return /*#__PURE__*/React.createElement(_IconThumbUpFill, props);
    case 'at':
      return /*#__PURE__*/React.createElement(_IconAt, props);
    case 'cloud_download':
      return /*#__PURE__*/React.createElement(_IconCloudDownload, props);
    case 'code_block':
      return /*#__PURE__*/React.createElement(_IconCodeBlock, props);
    case 'code_square':
      return /*#__PURE__*/React.createElement(_IconCodeSquare, props);
    case 'code':
      return /*#__PURE__*/React.createElement(_IconCode, props);
    case 'customer_service':
      return /*#__PURE__*/React.createElement(_IconCustomerService, props);
    case 'download':
      return /*#__PURE__*/React.createElement(_IconDownload, props);
    case 'export':
      return /*#__PURE__*/React.createElement(_IconExport, props);
    case 'eye_invisible':
      return /*#__PURE__*/React.createElement(_IconEyeInvisible, props);
    case 'eye':
      return /*#__PURE__*/React.createElement(_IconEye, props);
    case 'heart':
      return /*#__PURE__*/React.createElement(_IconHeart, props);
    case 'history':
      return /*#__PURE__*/React.createElement(_IconHistory, props);
    case 'home':
      return /*#__PURE__*/React.createElement(_IconHome, props);
    case 'import':
      return /*#__PURE__*/React.createElement(_IconImport, props);
    case 'launch':
      return /*#__PURE__*/React.createElement(_IconLaunch, props);
    case 'list':
      return /*#__PURE__*/React.createElement(_IconList, props);
    case 'message_banned':
      return /*#__PURE__*/React.createElement(_IconMessageBanned, props);
    case 'message':
      return /*#__PURE__*/React.createElement(_IconMessage, props);
    case 'more_vertical':
      return /*#__PURE__*/React.createElement(_IconMoreVertical, props);
    case 'more':
      return /*#__PURE__*/React.createElement(_IconMore, props);
    case 'poweroff':
      return /*#__PURE__*/React.createElement(_IconPoweroff, props);
    case 'refresh':
      return /*#__PURE__*/React.createElement(_IconRefresh, props);
    case 'reply':
      return /*#__PURE__*/React.createElement(_IconReply, props);
    case 'save':
      return /*#__PURE__*/React.createElement(_IconSave, props);
    case 'scan':
      return /*#__PURE__*/React.createElement(_IconScan, props);
    case 'search':
      return /*#__PURE__*/React.createElement(_IconSearch, props);
    case 'select_all':
      return /*#__PURE__*/React.createElement(_IconSelectAll, props);
    case 'send':
      return /*#__PURE__*/React.createElement(_IconSend, props);
    case 'settings':
      return /*#__PURE__*/React.createElement(_IconSettings, props);
    case 'share_alt':
      return /*#__PURE__*/React.createElement(_IconShareAlt, props);
    case 'share_external':
      return /*#__PURE__*/React.createElement(_IconShareExternal, props);
    case 'share_internal':
      return /*#__PURE__*/React.createElement(_IconShareInternal, props);
    case 'star':
      return /*#__PURE__*/React.createElement(_IconStar, props);
    case 'sync':
      return /*#__PURE__*/React.createElement(_IconSync, props);
    case 'thumb_down':
      return /*#__PURE__*/React.createElement(_IconThumbDown, props);
    case 'thumb_up':
      return /*#__PURE__*/React.createElement(_IconThumbUp, props);
    case 'translate':
      return /*#__PURE__*/React.createElement(_IconTranslate, props);
    case 'upload':
      return /*#__PURE__*/React.createElement(_IconUpload, props);
    case 'voice':
      return /*#__PURE__*/React.createElement(_IconVoice, props);
    case 'align_center':
      return /*#__PURE__*/React.createElement(_IconAlignCenter, props);
    case 'align_left':
      return /*#__PURE__*/React.createElement(_IconAlignLeft, props);
    case 'align_right':
      return /*#__PURE__*/React.createElement(_IconAlignRight, props);
    case 'attachment':
      return /*#__PURE__*/React.createElement(_IconAttachment, props);
    case 'bg_colors':
      return /*#__PURE__*/React.createElement(_IconBgColors, props);
    case 'bold':
      return /*#__PURE__*/React.createElement(_IconBold, props);
    case 'brush':
      return /*#__PURE__*/React.createElement(_IconBrush, props);
    case 'copy':
      return /*#__PURE__*/React.createElement(_IconCopy, props);
    case 'delete':
      return /*#__PURE__*/React.createElement(_IconDelete, props);
    case 'edit':
      return /*#__PURE__*/React.createElement(_IconEdit, props);
    case 'eraser':
      return /*#__PURE__*/React.createElement(_IconEraser, props);
    case 'filter':
      return /*#__PURE__*/React.createElement(_IconFilter, props);
    case 'find_replace':
      return /*#__PURE__*/React.createElement(_IconFindReplace, props);
    case 'font_colors':
      return /*#__PURE__*/React.createElement(_IconFontColors, props);
    case 'formula':
      return /*#__PURE__*/React.createElement(_IconFormula, props);
    case 'h1':
      return /*#__PURE__*/React.createElement(_IconH, props);
    case 'h2':
      return /*#__PURE__*/React.createElement(_IconH2, props);
    case 'h3':
      return /*#__PURE__*/React.createElement(_IconH3, props);
    case 'h4':
      return /*#__PURE__*/React.createElement(_IconH4, props);
    case 'h5':
      return /*#__PURE__*/React.createElement(_IconH5, props);
    case 'h6':
      return /*#__PURE__*/React.createElement(_IconH6, props);
    case 'h7':
      return /*#__PURE__*/React.createElement(_IconH7, props);
    case 'highlight':
      return /*#__PURE__*/React.createElement(_IconHighlight, props);
    case 'italic':
      return /*#__PURE__*/React.createElement(_IconItalic, props);
    case 'line_height':
      return /*#__PURE__*/React.createElement(_IconLineHeight, props);
    case 'link':
      return /*#__PURE__*/React.createElement(_IconLink, props);
    case 'oblique_line':
      return /*#__PURE__*/React.createElement(_IconObliqueLine, props);
    case 'ordered_list':
      return /*#__PURE__*/React.createElement(_IconOrderedList, props);
    case 'original_size':
      return /*#__PURE__*/React.createElement(_IconOriginalSize, props);
    case 'paste':
      return /*#__PURE__*/React.createElement(_IconPaste, props);
    case 'quote':
      return /*#__PURE__*/React.createElement(_IconQuote, props);
    case 'redo':
      return /*#__PURE__*/React.createElement(_IconRedo, props);
    case 'scissor':
      return /*#__PURE__*/React.createElement(_IconScissor, props);
    case 'sort_ascending':
      return /*#__PURE__*/React.createElement(_IconSortAscending, props);
    case 'sort_descending':
      return /*#__PURE__*/React.createElement(_IconSortDescending, props);
    case 'sort':
      return /*#__PURE__*/React.createElement(_IconSort, props);
    case 'strikethrough':
      return /*#__PURE__*/React.createElement(_IconStrikethrough, props);
    case 'underline':
      return /*#__PURE__*/React.createElement(_IconUnderline, props);
    case 'undo':
      return /*#__PURE__*/React.createElement(_IconUndo, props);
    case 'unordered_list':
      return /*#__PURE__*/React.createElement(_IconUnorderedList, props);
    case 'zoom_in':
      return /*#__PURE__*/React.createElement(_IconZoomIn, props);
    case 'zoom_out':
      return /*#__PURE__*/React.createElement(_IconZoomOut, props);
    case 'mute_fill':
      return /*#__PURE__*/React.createElement(_IconMuteFill, props);
    case 'pause_circle_fill':
      return /*#__PURE__*/React.createElement(_IconPauseCircleFill, props);
    case 'play_arrow_fill':
      return /*#__PURE__*/React.createElement(_IconPlayArrowFill, props);
    case 'play_circle_fill':
      return /*#__PURE__*/React.createElement(_IconPlayCircleFill, props);
    case 'skip_next_fill':
      return /*#__PURE__*/React.createElement(_IconSkipNextFill, props);
    case 'skip_previous_fill':
      return /*#__PURE__*/React.createElement(_IconSkipPreviousFill, props);
    case 'sound_fill':
      return /*#__PURE__*/React.createElement(_IconSoundFill, props);
    case 'backward':
      return /*#__PURE__*/React.createElement(_IconBackward, props);
    case 'forward':
      return /*#__PURE__*/React.createElement(_IconForward, props);
    case 'fullscreen_exit':
      return /*#__PURE__*/React.createElement(_IconFullscreenExit, props);
    case 'fullscreen':
      return /*#__PURE__*/React.createElement(_IconFullscreen, props);
    case 'live_broadcast':
      return /*#__PURE__*/React.createElement(_IconLiveBroadcast, props);
    case 'music':
      return /*#__PURE__*/React.createElement(_IconMusic, props);
    case 'mute':
      return /*#__PURE__*/React.createElement(_IconMute, props);
    case 'pause_circle':
      return /*#__PURE__*/React.createElement(_IconPauseCircle, props);
    case 'pause':
      return /*#__PURE__*/React.createElement(_IconPause, props);
    case 'play_arrow':
      return /*#__PURE__*/React.createElement(_IconPlayArrow, props);
    case 'play_circle':
      return /*#__PURE__*/React.createElement(_IconPlayCircle, props);
    case 'record_stop':
      return /*#__PURE__*/React.createElement(_IconRecordStop, props);
    case 'record':
      return /*#__PURE__*/React.createElement(_IconRecord, props);
    case 'skip_next':
      return /*#__PURE__*/React.createElement(_IconSkipNext, props);
    case 'skip_previous':
      return /*#__PURE__*/React.createElement(_IconSkipPrevious, props);
    case 'sound':
      return /*#__PURE__*/React.createElement(_IconSound, props);
    case 'bytedance_color':
      return /*#__PURE__*/React.createElement(_IconBytedanceColor, props);
    case 'lark_color':
      return /*#__PURE__*/React.createElement(_IconLarkColor, props);
    case 'tiktok_color':
      return /*#__PURE__*/React.createElement(_IconTiktokColor, props);
    case 'xigua_color':
      return /*#__PURE__*/React.createElement(_IconXiguaColor, props);
    case 'face_book_circle_fill':
      return /*#__PURE__*/React.createElement(_IconFaceBookCircleFill, props);
    case 'facebook_square_fill':
      return /*#__PURE__*/React.createElement(_IconFacebookSquareFill, props);
    case 'google_circle_fill':
      return /*#__PURE__*/React.createElement(_IconGoogleCircleFill, props);
    case 'qq_circle_fill':
      return /*#__PURE__*/React.createElement(_IconQqCircleFill, props);
    case 'twitter_circle_fill':
      return /*#__PURE__*/React.createElement(_IconTwitterCircleFill, props);
    case 'weibo_circle_fill':
      return /*#__PURE__*/React.createElement(_IconWeiboCircleFill, props);
    case 'alipay_circle':
      return /*#__PURE__*/React.createElement(_IconAlipayCircle, props);
    case 'code_sandbox':
      return /*#__PURE__*/React.createElement(_IconCodeSandbox, props);
    case 'codepen':
      return /*#__PURE__*/React.createElement(_IconCodepen, props);
    case 'facebook':
      return /*#__PURE__*/React.createElement(_IconFacebook, props);
    case 'github':
      return /*#__PURE__*/React.createElement(_IconGithub, props);
    case 'gitlab':
      return /*#__PURE__*/React.createElement(_IconGitlab, props);
    case 'google':
      return /*#__PURE__*/React.createElement(_IconGoogle, props);
    case 'qq_zone':
      return /*#__PURE__*/React.createElement(_IconQqZone, props);
    case 'qq':
      return /*#__PURE__*/React.createElement(_IconQq, props);
    case 'twitter':
      return /*#__PURE__*/React.createElement(_IconTwitter, props);
    case 'wechat':
      return /*#__PURE__*/React.createElement(_IconWechat, props);
    case 'wechatpay':
      return /*#__PURE__*/React.createElement(_IconWechatpay, props);
    case 'weibo':
      return /*#__PURE__*/React.createElement(_IconWeibo, props);
    case 'chinese_fill':
      return /*#__PURE__*/React.createElement(_IconChineseFill, props);
    case 'english_fill':
      return /*#__PURE__*/React.createElement(_IconEnglishFill, props);
    case 'face_frown_fill':
      return /*#__PURE__*/React.createElement(_IconFaceFrownFill, props);
    case 'face_meh_fill':
      return /*#__PURE__*/React.createElement(_IconFaceMehFill, props);
    case 'face_smile_fill':
      return /*#__PURE__*/React.createElement(_IconFaceSmileFill, props);
    case 'moon_fill':
      return /*#__PURE__*/React.createElement(_IconMoonFill, props);
    case 'pen_fill':
      return /*#__PURE__*/React.createElement(_IconPenFill, props);
    case 'sun_fill':
      return /*#__PURE__*/React.createElement(_IconSunFill, props);
    case 'apps':
      return /*#__PURE__*/React.createElement(_IconApps, props);
    case 'archive':
      return /*#__PURE__*/React.createElement(_IconArchive, props);
    case 'book':
      return /*#__PURE__*/React.createElement(_IconBook, props);
    case 'branch':
      return /*#__PURE__*/React.createElement(_IconBranch, props);
    case 'bug':
      return /*#__PURE__*/React.createElement(_IconBug, props);
    case 'bulb':
      return /*#__PURE__*/React.createElement(_IconBulb, props);
    case 'calendar_clock':
      return /*#__PURE__*/React.createElement(_IconCalendarClock, props);
    case 'calendar':
      return /*#__PURE__*/React.createElement(_IconCalendar, props);
    case 'camera':
      return /*#__PURE__*/React.createElement(_IconCamera, props);
    case 'cloud':
      return /*#__PURE__*/React.createElement(_IconCloud, props);
    case 'command':
      return /*#__PURE__*/React.createElement(_IconCommand, props);
    case 'common':
      return /*#__PURE__*/React.createElement(_IconCommon, props);
    case 'compass':
      return /*#__PURE__*/React.createElement(_IconCompass, props);
    case 'copyright':
      return /*#__PURE__*/React.createElement(_IconCopyright, props);
    case 'dashboard':
      return /*#__PURE__*/React.createElement(_IconDashboard, props);
    case 'desktop':
      return /*#__PURE__*/React.createElement(_IconDesktop, props);
    case 'dice':
      return /*#__PURE__*/React.createElement(_IconDice, props);
    case 'drag_dot_vertical':
      return /*#__PURE__*/React.createElement(_IconDragDotVertical, props);
    case 'drag_dot':
      return /*#__PURE__*/React.createElement(_IconDragDot, props);
    case 'drive_file':
      return /*#__PURE__*/React.createElement(_IconDriveFile, props);
    case 'ear':
      return /*#__PURE__*/React.createElement(_IconEar, props);
    case 'email':
      return /*#__PURE__*/React.createElement(_IconEmail, props);
    case 'empty':
      return /*#__PURE__*/React.createElement(_IconEmpty, props);
    case 'experiment':
      return /*#__PURE__*/React.createElement(_IconExperiment, props);
    case 'file_audio':
      return /*#__PURE__*/React.createElement(_IconFileAudio, props);
    case 'file_image':
      return /*#__PURE__*/React.createElement(_IconFileImage, props);
    case 'file_pdf':
      return /*#__PURE__*/React.createElement(_IconFilePdf, props);
    case 'file_video':
      return /*#__PURE__*/React.createElement(_IconFileVideo, props);
    case 'file':
      return /*#__PURE__*/React.createElement(_IconFile, props);
    case 'fire':
      return /*#__PURE__*/React.createElement(_IconFire, props);
    case 'folder_add':
      return /*#__PURE__*/React.createElement(_IconFolderAdd, props);
    case 'folder_delete':
      return /*#__PURE__*/React.createElement(_IconFolderDelete, props);
    case 'folder':
      return /*#__PURE__*/React.createElement(_IconFolder, props);
    case 'gift':
      return /*#__PURE__*/React.createElement(_IconGift, props);
    case 'idcard':
      return /*#__PURE__*/React.createElement(_IconIdcard, props);
    case 'image_close':
      return /*#__PURE__*/React.createElement(_IconImageClose, props);
    case 'image':
      return /*#__PURE__*/React.createElement(_IconImage, props);
    case 'interaction':
      return /*#__PURE__*/React.createElement(_IconInteraction, props);
    case 'language':
      return /*#__PURE__*/React.createElement(_IconLanguage, props);
    case 'layout':
      return /*#__PURE__*/React.createElement(_IconLayout, props);
    case 'loading':
      return /*#__PURE__*/React.createElement(_IconLoading, props);
    case 'location':
      return /*#__PURE__*/React.createElement(_IconLocation, props);
    case 'lock':
      return /*#__PURE__*/React.createElement(_IconLock, props);
    case 'loop':
      return /*#__PURE__*/React.createElement(_IconLoop, props);
    case 'man':
      return /*#__PURE__*/React.createElement(_IconMan, props);
    case 'menu':
      return /*#__PURE__*/React.createElement(_IconMenu, props);
    case 'mind_mapping':
      return /*#__PURE__*/React.createElement(_IconMindMapping, props);
    case 'mobile':
      return /*#__PURE__*/React.createElement(_IconMobile, props);
    case 'moon':
      return /*#__PURE__*/React.createElement(_IconMoon, props);
    case 'mosaic':
      return /*#__PURE__*/React.createElement(_IconMosaic, props);
    case 'nav':
      return /*#__PURE__*/React.createElement(_IconNav, props);
    case 'notification_close':
      return /*#__PURE__*/React.createElement(_IconNotificationClose, props);
    case 'notification':
      return /*#__PURE__*/React.createElement(_IconNotification, props);
    case 'palette':
      return /*#__PURE__*/React.createElement(_IconPalette, props);
    case 'pen':
      return /*#__PURE__*/React.createElement(_IconPen, props);
    case 'phone':
      return /*#__PURE__*/React.createElement(_IconPhone, props);
    case 'printer':
      return /*#__PURE__*/React.createElement(_IconPrinter, props);
    case 'public':
      return /*#__PURE__*/React.createElement(_IconPublic, props);
    case 'pushpin':
      return /*#__PURE__*/React.createElement(_IconPushpin, props);
    case 'qrcode':
      return /*#__PURE__*/React.createElement(_IconQrcode, props);
    case 'robot_add':
      return /*#__PURE__*/React.createElement(_IconRobotAdd, props);
    case 'robot':
      return /*#__PURE__*/React.createElement(_IconRobot, props);
    case 'safe':
      return /*#__PURE__*/React.createElement(_IconSafe, props);
    case 'schedule':
      return /*#__PURE__*/React.createElement(_IconSchedule, props);
    case 'shake':
      return /*#__PURE__*/React.createElement(_IconShake, props);
    case 'skin':
      return /*#__PURE__*/React.createElement(_IconSkin, props);
    case 'stamp':
      return /*#__PURE__*/React.createElement(_IconStamp, props);
    case 'storage':
      return /*#__PURE__*/React.createElement(_IconStorage, props);
    case 'subscribe_add':
      return /*#__PURE__*/React.createElement(_IconSubscribeAdd, props);
    case 'subscribe':
      return /*#__PURE__*/React.createElement(_IconSubscribe, props);
    case 'subscribed':
      return /*#__PURE__*/React.createElement(_IconSubscribed, props);
    case 'sun':
      return /*#__PURE__*/React.createElement(_IconSun, props);
    case 'tag':
      return /*#__PURE__*/React.createElement(_IconTag, props);
    case 'tags':
      return /*#__PURE__*/React.createElement(_IconTags, props);
    case 'thunderbolt':
      return /*#__PURE__*/React.createElement(_IconThunderbolt, props);
    case 'tool':
      return /*#__PURE__*/React.createElement(_IconTool, props);
    case 'trophy':
      return /*#__PURE__*/React.createElement(_IconTrophy, props);
    case 'unlock':
      return /*#__PURE__*/React.createElement(_IconUnlock, props);
    case 'user_add':
      return /*#__PURE__*/React.createElement(_IconUserAdd, props);
    case 'user_group':
      return /*#__PURE__*/React.createElement(_IconUserGroup, props);
    case 'user':
      return /*#__PURE__*/React.createElement(_IconUser, props);
    case 'video_camera':
      return /*#__PURE__*/React.createElement(_IconVideoCamera, props);
    case 'wifi':
      return /*#__PURE__*/React.createElement(_IconWifi, props);
    case 'woman':
      return /*#__PURE__*/React.createElement(_IconWoman, props);
    default:
      if (placeholder) {
        return /*#__PURE__*/React.createElement(_Avatar, {
          size: 20,
          style: {
            marginRight: -4
          },
          shape: "square"
        });
      } else {
        return null;
      }
  }
}
function IconPicker(props) {
  const value = props.value || {};
  const [searchText, setSearchText] = useState('');
  const [visible, setVisible] = React.useState(false);
  // 过滤图标
  const filteredIcons = iconNames.filter(name => name.toLowerCase().includes(searchText.toLowerCase()));
  const onPickerIcon = function (name) {
    props.onChange && props.onChange(name);
    setVisible(false);
  };

  // 渲染图标列表
  const iconList = /*#__PURE__*/React.createElement("div", {
    style: {
      width: 308,
      height: 300
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon-picker-toolbar']
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u641C\u7D22\u56FE\u6807",
    value: searchText,
    allowClear: true,
    onChange: icno_name => setSearchText(icno_name)
  }), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    onClick: () => onPickerIcon('')
  }, "\u6E05\u7A7A")), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 250,
      overflowX: 'hidden',
      overflowY: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Row, {
    gutter: [12, 12]
  }, filteredIcons.map(name => {
    return /*#__PURE__*/React.createElement(Col, {
      span: 4,
      key: name
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        cursor: 'pointer',
        border: value === name ? '2px solid var(--color-primary)' : '1px solid var(--color-border)',
        borderRadius: 0
      },
      onClick: () => onPickerIcon?.(name)
    }, getIconFromKey(name, {
      style: {
        fontSize: 20
      }
    })));
  }))));
  return props.picker ? /*#__PURE__*/React.createElement(_Popover, {
    trigger: "click",
    popupVisible: visible,
    onVisibleChange: setVisible,
    content: iconList
  }, /*#__PURE__*/React.createElement(_Tag, {
    size: "large",
    color: "gray",
    icon: value ? getIconFromKey(value, props.props, true) : null,
    className: styles['icon-picker-tag']
  }, value ? `` : '请选择图标')) : getIconFromKey(value, props.props, false);
}
export default IconPicker;